
// eslint-disable-next-line no-unused-vars
import clip from '@/utils/clipboard'; // use clipboard directly

export default {
  props: {
    config: {
      type: Object,
      default: function _default() {}
    }
  },
  components: {},
  data: function data() {
    return {};
  },

  methods: {
    handleReload: function handleReload() {
      this.$emit('reload');
    }
  },
  watch: {},
  mounted: function mounted() {}
};